import { Outlet, Link, useLocation } from 'react-router-dom';
import { clsx } from '@/utils';
import { storage } from '@/utils';
import type { User } from '@/types';

export const Layout = () => {
  const location = useLocation();
  const token = storage.get('token');
  const user = storage.get<User>('user') || null;
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-8">
              <Link to="/" className="text-xl font-bold text-primary-600">
                企业前端框架
              </Link>
              
              <nav className="hidden md:flex space-x-6">
                <Link
                  to="/"
                  className={clsx(
                    'px-3 py-2 text-sm font-medium rounded-md',
                    isActive('/') 
                      ? 'text-primary-600 bg-primary-50' 
                      : 'text-gray-700 hover:text-primary-600'
                  )}
                >
                  首页
                </Link>
                
                {!!token && (
                  <>
                    <Link
                      to="/dashboard"
                      className={clsx(
                        'px-3 py-2 text-sm font-medium rounded-md',
                        isActive('/dashboard')
                          ? 'text-primary-600 bg-primary-50'
                          : 'text-gray-700 hover:text-primary-600'
                      )}
                    >
                      控制台
                    </Link>

                    <Link
                      to="/profile"
                      className={clsx(
                        'px-3 py-2 text-sm font-medium rounded-md',
                        isActive('/profile')
                          ? 'text-primary-600 bg-primary-50'
                          : 'text-gray-700 hover:text-primary-600'
                      )}
                    >
                      个人资料
                    </Link>
                  </>
                )}
              </nav>
            </div>
            
            <div className="flex items-center space-x-4">
              {!!token ? (
                <div className="flex items-center space-x-4">
                  <span className="text-sm text-gray-700">
                    欢迎，{user?.name || '用户'}
                  </span>
                  <Link
                    to="/login"
                    className="text-sm text-gray-500 hover:text-gray-700"
                    onClick={() => {
                      storage.remove('token');
                      storage.remove('refreshToken');
                      storage.remove('user');
                    }}
                  >
                    退出
                  </Link>
                </div>
              ) : (
                <Link
                  to="/login"
                  className="bg-primary-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-700"
                >
                  登录
                </Link>
              )}
            </div>
          </div>
        </div>
      </header>
      
      <main className="flex-1">
        <Outlet />
      </main>
      
      <footer className="bg-white border-t border-gray-200 mt-12">
        <div className="container mx-auto px-4 py-6">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-500">
              © 2024 企业级前端框架. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-sm text-gray-500 hover:text-gray-700">
                文档
              </a>
              <a href="#" className="text-sm text-gray-500 hover:text-gray-700">
                支持
              </a>
              <a href="#" className="text-sm text-gray-500 hover:text-gray-700">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};